import api from "./api";

// Camada de serviço do Módulo de Catálogo de Produtos / Tabela de Preços + Estoque.
// Encapsula todos os endpoints (base já inclui /api/bpf/ no api.js) e normaliza o envelope.
//
// Regra do contrato (api-contrato-produtos.md §2):
//   - index (listagens) e /full  -> payload CRU em resp.data
//   - create/update/delete/show  -> envelope: resp.data.data.result

// Desembrulha o envelope padrão { success, data: { message, result } }.
function unwrap(resp) {
  return resp.data && resp.data.data ? resp.data.data.result : resp.data;
}

// ----- Grupos de Produtos -----
const listGroups = (domain) =>
  api.get("product-groups", { params: { domain } }).then((resp) => resp.data);

const getGroupFull = (id) =>
  api.get(`product-groups/${id}/full`).then((resp) => resp.data);

const createGroup = (payload) =>
  api.post("product-groups", payload).then(unwrap);

const updateGroup = (id, payload) =>
  api.put(`product-groups/${id}`, payload).then(unwrap);

const deleteGroup = (id) =>
  api.delete(`product-groups/${id}`).then(unwrap);

// ----- Tabelas de Preço (colunas do grupo) -----
const listPriceTables = (productGroupId) =>
  api
    .get("price-tables", { params: { product_group_id: productGroupId } })
    .then((resp) => resp.data);

const createPriceTable = (payload) =>
  api.post("price-tables", payload).then(unwrap);

const updatePriceTable = (id, payload) =>
  api.put(`price-tables/${id}`, payload).then(unwrap);

const deletePriceTable = (id) =>
  api.delete(`price-tables/${id}`).then(unwrap);

// ----- Produtos -----
// Todos os produtos da empresa (catálogo global). Payload cru.
const listAllProducts = (domain) =>
  api.get("products", { params: { domain } }).then((resp) => resp.data);

// Vincula um produto EXISTENTE a um grupo (reuso entre catálogos). Envelope.
// payload: { product_id, prices?: [{ price_table_id, price }] }
const attachProductToGroup = (groupId, payload) =>
  api.post(`product-groups/${groupId}/products`, payload).then(unwrap);

// Desvincula o produto do grupo (não apaga o produto). Envelope.
const detachProductFromGroup = (groupId, productId) =>
  api.delete(`product-groups/${groupId}/products/${productId}`).then(unwrap);

const createProduct = (payload) =>
  api.post("products", payload).then(unwrap);

// PUT com prices[] faz upsert por price_table_id; sem prices, não mexe nos preços.
const updateProduct = (id, payload) =>
  api.put(`products/${id}`, payload).then(unwrap);

const deleteProduct = (id) =>
  api.delete(`products/${id}`).then(unwrap);

// ----- Estoque (movimentações imutáveis) -----
const listStockMovements = (productId) =>
  api.get(`products/${productId}/stock-movements`).then((resp) => resp.data);

// payload: { type: "in" | "out" | "adjustment", quantity, reason? }
const registerMovement = (productId, payload) =>
  api.post(`products/${productId}/stock-movements`, payload).then(unwrap);

export default {
  listGroups,
  getGroupFull,
  createGroup,
  updateGroup,
  deleteGroup,
  listPriceTables,
  createPriceTable,
  updatePriceTable,
  deletePriceTable,
  listAllProducts,
  attachProductToGroup,
  detachProductFromGroup,
  createProduct,
  updateProduct,
  deleteProduct,
  listStockMovements,
  registerMovement,
};
